import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-standard-template',
  templateUrl: './admin-standard-template.component.html',
  styleUrls: ['./admin-standard-template.component.css']
})
export class AdminStandardTemplateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/user/Desktop/otojet-git/OtojetUI-Spring-Admin-Project/src/app/admin-standard-template/admin-standard-template.component.ts